import { EvaluationVehicle } from "./evaluation";
import { AuctionStatus, FuelEnum, TransmissionEnum } from "./vehicle";

export class FastQuoteQuantity {
  expiration: Date;
  expirationTimeLeft: number;
  numActive: number;
}

export class LongFastQuoteResponse {
  longFastQuote?: boolean;
}

export class FastQuoteSearch {
  actualPage: number;
  data: FastQuoteItem[];
  numberOfPages: number;
  totalElements: number;
}

export class FastQuoteItem {
  bidValue: number;
  boughtByMe: boolean;
  carManual: boolean;
  city: string;
  expiration: Date;
  expirationTimeLeft: number;
  extraKey: boolean;
  fastQuoteId: string;
  fuel: FuelEnum;
  id: string;
  imgUrls: string[];
  km: number;
  make: string;
  manufactureYear: number;
  model: string;
  modelYear: number;
  ownsAnyBid: boolean;
  soldAt: Date;
  status: AuctionStatus;
  transmission: TransmissionEnum;
  trim: string;
  uf: string;
  views: number;
}

export enum FastQuoteCancelStatus {
  FAST_QUOTE_NOT_FOUND = "Cotação não encontrada",
  CANT_CANCEL = "Não é possível cancelar a cotação",
  VEHICLE_NOT_FOUND = "Veículo não encontrado",
  DONT_OWN_VEHICLE = "Sem permissão para este veículo"
}

export enum BidSuggestionStatus {
    INACTIVE = "Cotação inativa",
    SOLD = "Veículo vendido",
    EXPIRED = "Cotação expirada",
    DELETED = "Cotação deletada",
    NOT_A_DEALER = "O comprador não está habilitado",
    DONT_OWN_VEHICLE = "O usuário está vinculado ao anunciante",
    NO_VEHICLE = "Veículo não encontrado",
    CANT_BID_ON_OWN_VEHICLE = "Não é possível fazer uma oferta nos seus próprios veículos.",
    BID_SUGGESTION_NOT_FOUND = "Proposta não encontrada",
    LATE_PAYMENT = "Possui boletos atrasados",
    LESS_THAN_MIN_BID = "Valor abaixo da oferta mínima",
    CANT_MAKE_COUNTER_OFFER = "Não é possível fazer uma contra proposta.",
    NO_COUNTER_OFFER = "Contra proposta não encontrada",
    COUNTER_OFFER_AWAITING_RESPONSE = "Contra proposta aguardando resposta",
    NOT_AN_EXCLUSIVE_DEALER = "Você não tem acesso a este grupo exclusivo.",
    UNKNOWN_ERROR = "Ocorreu um erro desconhecido",
    CANNOT_CREATE_AUCTION_FROM_EVAL = "Não é possível gerar a venda a partir de uma avaliação.",
    ONLY_HIGHEST_BID_ALLOWED = "Apenas a maior oferta pode ser aceita em cotações competitivas.", 
    NO_BIDS = "Não há ofertas para esta cotação.",
    BELOW_MINIMUM_MARGIN = "A proposta está abaixo da margem mínima configurada."
}